import { isEmpty } from 'lodash';

export const HEATLHCARE_HEADERS = {
  headers: {
    'x-api-key': process.env.REACT_APP_HEALTHCARE_API_KEY,
  },
};
export const TPZ_HEADERS = {
  headers: {
    'x-api-key': process.env.REACT_APP_THEPARENTZ_API_KEY,
  },
};

export const shortToFullDay = {
  Mon: 'Monday',
  Tue: 'Tuesday',
  Wed: 'Wednesday',
  Thu: 'Thursday',
  Fri: 'Friday',
  Sat: 'Saturday',
  Sun: 'Sunday',
};

export const parseAvailabilityData = (data) => {
  const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  let result = [];

  if (isEmpty(data)) {
    return [];
  }

  data.forEach((item) => {
    const daysRange = item['days'];
    const timeSlots = item['timing'];
    if (daysRange?.includes(' - ')) {
      const [startDay, endDay] = daysRange.split(' - ');

      // Map short day names to full names

      // Convert the startDay and endDay to full names
      const fullStartDay = shortToFullDay[startDay];
      const fullEndDay = shortToFullDay[endDay];

      const startIdx = weekdays?.indexOf(fullStartDay);
      const endIdx = weekdays?.indexOf(fullEndDay);

      // Map through the range of days
      for (let i = startIdx; i <= endIdx; i++) {
        result.push({
          day: weekdays[i],
          timeSlots: timeSlots, // Joining all time slots for that day
        });
      }
    } else {
      // For a specific day like "Sun"
      result.push({
        day: shortToFullDay[daysRange],
        timeSlots: timeSlots, // Joining all time slots for that day
      });
    }
  });

  return result;
};
